import FileReferenceDefinition from '../FileReferenceDefinition';

const definition: FileReferenceDefinition = {
  name: 'StandaloneDragData',
  type: 'class',
  description: "Drag data for [StandaloneWebView.DragDataChanged](/webview/StandaloneWebView#DragDataChanged).",
  members: [
    {
      name: 'HasImage',
      returns: 'bool',
      type: 'property',
      description: "Indicates whether a thumbnail image representation is available for the drag interaction. If `true`, the application can access the image via the Image field."
    },
    {
      name: 'ImageWidth',
      returns: 'int',
      type: 'property',
      description: "The width of Image in pixels, or `0` if HasImage is `false`."
    },
    {
      name: 'ImageHeight',
      returns: 'int',
      type: 'property',
      description: "The height of Image in pixels, or `0` if HasImage is `false`."
    },
    {
      name: 'Image',
      returns: 'byte[]',
      type: 'property',
      description: "A thumbnail image for the dragged item in PNG format if HasImage is `true`, or `null` otherwise."
    },
  ]
};
export default definition;
